export interface Station {
  id: string;
  name: string;
  /** Station call letters from selection API (e.g. WXYZ) */
  callLetters?: string;
  nowPlaying?: NowPlaying;
}

export interface NowPlaying {
  title: string;
  artist: string;
  album?: string;
  artwork?: string;
}

export interface Category {
  id: string;
  name: string;
  color: string;
  isPrivate: boolean;
  isDefault: boolean;
}

export interface HotKey {
  id: string;
  name: string;
  messageText: string;
  rt1?: string;
  rt2?: string;
  messageImage?: string;
  /** Tile background from API when provided; falls back to category color (#20). */
  tileColor?: string;
  type: MessageType;
  categoryId: string;
  category: Category;
  isActive: boolean;
  keepAliveMinutes: number;
  rotationDurationSeconds: number;
  duringSettings: DuringSettings;
  timeRemaining?: number; // in seconds
  createdAt: Date;
  updatedAt: Date;
}

export enum MessageType {
  TAKEOVER = 'takeover',
  OVERRIDE = 'override',
  ROTATE_WITH = 'rotate_with'
}

export interface DuringSettings {
  music: boolean;
  ads: boolean;
  other: boolean;
}

export interface User {
  userName: string;
  userId: number;
  firstName: string;
  login: string;
  lastName: string;
  userRole: string;
  workPhone: string | null;
  mobile: string | null;
  fax: string | null;
  createdBy: string;
  createdByName: string;
  password: string | null;
  address: string | null;
  rights: string | null;
  rtRights: string;
  jumpGateRights: string | null;
  reportRights: string | null;
  adminRights: string | null;
  blastRights?: string | null;
  lastSelectedStation: number;
  token: string;
}

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface PreviewSendMode {
  mode: 'start' | 'stop';
  hotKey: HotKey;
  keepAliveMinutes?: number;
  timeRemaining?: number;
} 